// extracted by mini-css-extract-plugin
export default {"parent":"SingalCertificate_parent__suGp1","container":"SingalCertificate_container__Fn+XX","card":"SingalCertificate_card__O9L4M"};